import { useCobliConectaCandidates } from '@cobliteam/hooks/src/useEntity/useDevices/useCobliConectaCandidates';

export const useShouldShowCobliConecta = (): boolean => {
  const candidates = useCobliConectaCandidates();
  return candidates.length > 0;
};

export default useShouldShowCobliConecta;
